<main [class.margin-bottom]="marginBottom" [class.padding-top]="showActions">
  <ng-content></ng-content>
</main>
